__turbopack_context__.v({
  "accent": "info-chips-module-scss-module__beOZIW__accent",
  "caution": "info-chips-module-scss-module__beOZIW__caution",
  "children": "info-chips-module-scss-module__beOZIW__children",
  "compact": "info-chips-module-scss-module__beOZIW__compact",
  "contained": "info-chips-module-scss-module__beOZIW__contained",
  "default": "info-chips-module-scss-module__beOZIW__default",
  "dim": "info-chips-module-scss-module__beOZIW__dim",
  "error": "info-chips-module-scss-module__beOZIW__error",
  "icon": "info-chips-module-scss-module__beOZIW__icon",
  "info-chips": "info-chips-module-scss-module__beOZIW__info-chips",
  "large": "info-chips-module-scss-module__beOZIW__large",
  "medium": "info-chips-module-scss-module__beOZIW__medium",
  "outline": "info-chips-module-scss-module__beOZIW__outline",
  "primary": "info-chips-module-scss-module__beOZIW__primary",
  "round-accent": "info-chips-module-scss-module__beOZIW__round-accent",
  "round-contained": "info-chips-module-scss-module__beOZIW__round-contained",
  "round-outline": "info-chips-module-scss-module__beOZIW__round-outline",
  "secondary": "info-chips-module-scss-module__beOZIW__secondary",
  "small": "info-chips-module-scss-module__beOZIW__small",
  "success": "info-chips-module-scss-module__beOZIW__success",
  "text": "info-chips-module-scss-module__beOZIW__text",
  "x-large": "info-chips-module-scss-module__beOZIW__x-large",
});
